import React, { Component } from 'react';
import { Drawer, makeStyles } from "@mui/material";
import { withStyles } from "@mui/styles";
import NavBar from '../NavBar/NavBar';
import SideMenu from './SideMenu';
import { isMenuVisible } from '../NavBar/reducer';
import { closeMenu } from '../NavBar/actions';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import { ActionsAuth, getAuth } from '../../assets/redux/AuthRedux';
import PropTypes from 'prop-types';
import './styles.css';
import { GetRequest } from '../../assets/dataProvider';
import { CustomerDataDto, LoginResponse } from '../../dto/auth.dto';
import { History } from "history";
import ConfirmDialogSineOut from './ConfirmDialogSineOut';
interface Iprops {
    sideMenuVisible?: boolean;
    closeMenu: any;
    children?: any;
    visiable: boolean,
    classes: any,
    auth: LoginResponse,
    setAuthData: any,
    history: History<unknown>,
}
interface IState {
    isLoading: boolean,
    openDialog: boolean,
}
export interface match<P> {
    params: P;
    isExact: boolean;
    path: string;
    url: string;
}
class Sidbar extends React.Component<Iprops, IState> {

    constructor(props: any) {
        super(props);
        this.state = { isLoading: true, openDialog: false };
        this.hideSidebar = this.hideSidebar.bind(this);
    }
    componentDidMount() {
        this.loadCustomerData();
    }
    closeDialog = (confirm: boolean) => {
        this.setState({ openDialog: false });
        if (confirm) {
            this.props.history.replace('/app/signout');
        }
    }
    async loadCustomerData() {
        if (this.props.history.location.pathname.includes('/app')) {
            var data = await GetRequest('api/v2/customers/customerData', {}, this.props.auth);

            if (data && data.success) {
                let authData = { ...this.props.auth };
                var entity = data.entity as CustomerDataDto;
                authData.photoSrc = entity.avatar;
                authData.fullName = entity.nationalcode;
                authData.credit = entity.credit;
                authData.fullName = entity.fullName;
                authData.mobile = entity.mobile;
                this.props.setAuthData(authData);
            }
            else {
              
                this.props.history.replace('/app/signout');
            }
        }
    }
    hideSidebar() {
        if (this.props.sideMenuVisible && this.props.closeMenu) {
            this.props.closeMenu();
        }
    }
    render() {
        const { classes, auth } = this.props;
        return (
            <React.Fragment>
                {this.props.visiable && <NavBar />}
                <ReduxToastr
                    timeOut={4000}
                    newestOnTop
                    preventDuplicates
                    position="top-center"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                />
                <Drawer
                    hidden={!this.props.visiable}
                    anchor={"right"}
                    open={this.props.sideMenuVisible ? true : false}
                    onClose={this.props.closeMenu}

                >
                    <SideMenu isVisible={this.props.sideMenuVisible ? true : false}
                        closeMenu={this.props.closeMenu} onClickSingout={() => { this.setState({ openDialog: true }); }} />

                </Drawer>
                <div id="container" className={(auth && auth.token) ? classes.containerAuth : classes.container}>
                    {this.props.children}
                </div>
                <ConfirmDialogSineOut openDialog={this.state.openDialog} closeModal={this.closeDialog} />
            </React.Fragment>

        );
    }
}



const mapStateToProps = (state: any) => ({
    sideMenuVisible: isMenuVisible(state.navbar),
    auth: getAuth(state.AuthRedux)
});
const mapDispatchToProps = (dispatch: any) => ({
    setAuthData: (authData: LoginResponse) => {
        dispatch(ActionsAuth.SetAuthData(authData));
    },
    closeMenu: () => {

        dispatch(closeMenu())
    }
});
(Sidbar as any).propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
};
const useStyles = (theme: any) => ({
    containerAuth: {
        backgroundColor: theme.container.backgroundColor,
        top: "60px"
    },
    container: {
        backgroundColor: theme.container.backgroundColor,
        top: "0px"
    },
});
export default
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withStyles(useStyles, { withTheme: true })(Sidbar));

